module.exports = __webpack_public_path__ + "img/7_22.8815bac4.png";